// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"526":"f897b245","540":"566b4377","613":"8929637d","861":"07f891bd","991":"410cc8b6"}[chunkId] + ".chunk.css";
};